// extracted by mini-css-extract-plugin
module.exports = {"main":"parentScreener_main__2KwHO","iframe":"parentScreener_iframe__2MllN"};